import React from 'react';
import moment from 'moment-timezone';
import './pageWelcome.css'
import { Typography, List, Card } from 'antd';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Text } = Typography;

const PageWelcome = ({ selectedEvaluation, totalResults, individualResults, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <Title level={4} style={{ color: '#339C98', marginBottom: 16 }}>
                        Reporte Individual
                    </Title>
                    <div className='welcome-page-text'>
                        Bienvenido(a).
                        <br /><br />
                        Quiero felicitarte por iniciar este proceso de crecimiento personal y arriesgarte a
                        mirar dentro de ti y permitir a otros que aporten desde su percepción como te ven
                        en tu labor diaria como líder; sé que no es nada fácil; es un proceso que requiere
                        valentía, amor propio y sobre todo un profundo deseo de crecer, de alcanzar
                        metas y sueños y de hacer de ti una persona que aporte al mundo para hacerlo
                        mucho mejor.
                        <br /><br />
                        Todos podemos ser lideres; al final como dice Jhon Maxwell el “liderazgo es
                        influencia; es hacer que las cosas pasen a través de otros” y si te lo propones; en
                        la medida que crezcas como persona tu capacidad de liderar se va a incrementar;
                        pero primero necesitas entender cómo estas hoy y a donde quieres llegar.
                        <br /><br />
                        Este reporte constituye una de las herramientas más valiosas para el desarrollo de
                        tu liderazgo, en él se encuentra información de cómo otras personas te ven como
                        líder, la cual actúa como pilar fundamental para trazar la hoja de ruta que guiara
                        este proceso.
                        <br /><br />
                        Queremos que al recibir este reporte hagas un Pare, Piense y posteriormente
                        actúes; date la oportunidad de entender cómo los demás te ven versus cómo te
                        ves tu mismo. Más allá de ser considerado un conjunto de resultados, este reporte
                        debe ser visto como la piedra angular de un proceso que llevado adecuadamente,
                        permitirá tu crecimiento como líder al interior de la organización.
                        <br /><br />
                        A medida que lo analizas, ten en cuenta lo siguiente:
                        <br /><br />
                        No tomes acción inmediata. Durante el taller “Liderazgo 360” desarrollarás un plan
                        integral de acción. Por esto te recomendamos que no actúes hasta que hayas
                        entendido plenamente tu retroalimentación y cuentes con las herramientas para
                        hacer cambios efectivos.
                        <br /><br />
                        Has una evaluación juiciosa y de alto nivel en busca de áreas que resalten, luego
                        deja el reporte a un lado hasta el taller.
                    </div>
                </div>
                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageWelcome;
